/**
 * Backend answers 403 { error: LEGAL_ACCEPTANCE_REQUIRED } on purchases until every active legal document
 * is accepted (v1.48.0). apiClient fires LEGAL_REQUIRED_EVENT instead of refreshing the token / alerting,
 * App re-reads the status and the consent window opens again.
 */
export const LEGAL_ACCEPTANCE_REQUIRED = 'LEGAL_ACCEPTANCE_REQUIRED';
export const LEGAL_REQUIRED_EVENT = 'datum:legal-required';

export const isLegalAcceptanceRequired = (error) =>
  error?.response?.status === 403 && error?.response?.data?.error === LEGAL_ACCEPTANCE_REQUIRED;
